const app = {
  state: {
    INTERFACE_ON_OFF: 'on',
    cache: [],
  },
  getters: {
    getCache: state => {
      return state.cache;
    }
  },
  mutations: {
    setCache: (state, val) => {
      state.cache.push(val);
      const unique = function (arr) {
        const n = [];
        for (let i = 0; i < arr.length; i++) {
          if (n.indexOf(arr[i]) === -1) n.push(arr[i]);
        }
        return n;
      };
      state.cache = unique(state.cache);
    },
    delCache: (state, val) => {
      const i = state.cache.indexOf(val);
      (i > -1) && state.cache.splice(i, 1);
    },
  }
}

export default app;